import { render, staticRenderFns } from "./EditDebtorStatusDialog.vue?vue&type=template&id=6bd18614&"
import script from "./EditDebtorStatusDialog.vue?vue&type=script&lang=js&"
export * from "./EditDebtorStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports